import { gql } from 'apollo-angular';

export const SUBSCRIBE_EMAIL = gql`
  mutation SubscribeEmail($email: String!) {
    subscribeEmail(email: $email) {
      id
      email
      status
      subscribedAt
    }
  }
`;
